import React, { useState } from 'react';

function SurveyStepSeven({ formData, onNext }) {
    const [roleAlignment, setRoleAlignment] = useState(formData.roleAlignment || '');
    const [careerComments, setCareerComments] = useState(formData.careerComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!roleAlignment) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ roleAlignment, careerComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 2: Career Development</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How well does your current role align with your long-term career goals? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`role-alignment-${option}`}
                            name="roleAlignment"
                            value={option}
                            checked={roleAlignment === option}
                            onChange={() => setRoleAlignment(option)}
                        />
                        <label htmlFor={`role-alignment-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={careerComments}
                    onChange={(e) => setCareerComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!roleAlignment}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepSeven;
